import { onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useViewport } from '@/composables/useViewport.js'

const DENSITY_CLASS = 'product-ui-density'

function setProductDensityClass(enabled) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle(DENSITY_CLASS, enabled)
}

export function useProductDensity() {
  const route = useRoute()
  const { isMobile } = useViewport()

  function sync() {
    const enabled = route.meta.productDensity === true && !isMobile.value
    setProductDensityClass(enabled)
  }

  watch(
    () => [route.meta.productDensity, route.path, isMobile.value],
    () => sync(),
    { immediate: true },
  )

  onMounted(() => sync())

  onUnmounted(() => {
    setProductDensityClass(false)
  })
}
